<div class="row">
    <div class="col-md-12 col-xs-12 vh-100">
            <div class="d-flex flex-column" >
                <div class="flex-grow-1">
                    <ag-grid-angular
                        style="width: 100%; height: 100%;"
                        class="ag-theme-alpine"
                        (gridReady)="gridSetting($event)"
                        (firstDataRendered)="restoreGridState($event)"
                        (paginationChanged)="saveGridState($event)"
                        (sortChanged)="saveGridState($event)"
                        [gridOptions]="gridOptions"
                        [rowData]="tankers"
                        [columnDefs]="columnDefs"
                        [pagination]= "true"
                        [paginationPageSize]="10"
                        [paginationPageSizeSelector]="[10,20,30]"
                        [enableCellTextSelection]="true"
                        >
                    </ag-grid-angular>
                </div>
            </div>
        </div>
</div>
